import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Landing from "./pages/Landing";
import Assessment from "./pages/Assessment";
import Results from "./pages/Results";
import Saved from "./pages/Saved";
import PublicResults from "./pages/PublicResults";
import AdminLeads from "./pages/AdminLeads";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-10 h-10 animate-spin text-brand-primary" /></div>;
  }
  if (user === false) return <Navigate to="/" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-10 h-10 animate-spin text-brand-primary" /></div>;
  }
  if (user) return <Navigate to="/assessment" replace />;
  return children;
}

function Shell() {
  return (
    <div className="min-h-screen bg-brand-bg">
      <Navbar />
      <Routes>
        <Route path="/" element={<PublicOnly><Landing /></PublicOnly>} />
        <Route path="/share/:id" element={<PublicResults />} />
        <Route path="/assessment" element={<Protected><Assessment /></Protected>} />
        <Route path="/results" element={<Protected><Results /></Protected>} />
        <Route path="/saved" element={<Protected><Saved /></Protected>} />
        <Route path="/admin/leads" element={<Protected><AdminLeads /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" toastOptions={{ style: { border: "2px solid black", borderRadius: "12px", fontWeight: 700 } }} />
        <Shell />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
